import { render } from "./EditSelectionModal.vue?vue&type=template&id=e4a882a0"
import script from "./EditSelectionModal.vue?vue&type=script&lang=js"
export * from "./EditSelectionModal.vue?vue&type=script&lang=js"

import "./EditSelectionModal.vue?vue&type=style&index=0&id=e4a882a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__